import { useLocation } from "react-router-dom";
import {
  ConditionalRenderer,
  Header,
  useLanguageTranslator,
} from "../../../components";
import {
  CountryAction,
  ThemesAction,
  GeographicalAction,
  PolicyCategoriesAction,
  PracticeCategoriesAction,
} from "../parameters/features";
import { Stack, Typography } from "@mui/material";
import { IndicatorValuesAction } from "../data/features";
import { IndicatorAction } from "../parameters/features/indicatorsAction";
import { UsersAction } from "../accounts/features";
import { ProfileAction } from "../accounts/features/profileAction";
import { IndicatorsCategoriesAction } from "../parameters/features/indicatorsCategoriesAction";
import { InstitutionsAction } from "../parameters/features/institutionsAction";
import { RolesAction } from "../parameters/features/roleAction";

const moduleKeys = {
  country: "country",
  themes: "themes",
  geographicalArea: "geographical-area",
  policyCategories: "policy-categories",
  practiceCategories: "practice-categories",
  indicatorsCategories: "indicators-categories",
  indicatorsValues: "indicators-values",
  indicators: "indicators",
  users: "users",
  profiles: "profiles",
  institutions: "institutions",
  role: "role",
};

function AddFeatures() {
  const location = useLocation();
  const moduleName = location?.pathname?.split("/")?.[2];
  const { translator } = useLanguageTranslator();

  function returnTitle(moduleKeys: any, moduleName: any) {
    if (moduleKeys?.country === moduleName) {
      return translator("Country");
    }
    if (moduleKeys?.themes === moduleName) {
      return `${translator("Theme")}s`;
    }
    if (moduleKeys?.geographicalArea === moduleName) {
      return translator("Geographical Area");
    }
    if (moduleKeys?.policyCategories === moduleName) {
      return translator("Policy Categories");
    }

    if (moduleKeys?.indicatorsCategories === moduleName) {
      return translator("Indicators Categories");
    }

    if (moduleKeys?.indicatorsValues === moduleName) {
      return translator("Indicators Values");
    }

    if (moduleKeys?.indicators === moduleName) {
      return translator("Indicators");
    }

    if (moduleKeys?.users === moduleName) {
      return translator("Users");
    }

    if (moduleKeys?.profiles === moduleName) {
      return translator("generic.Profile");
    }

    if (moduleKeys?.institutions === moduleName) {
      return translator("Institutions");
    }

    if (moduleKeys?.role === moduleName) {
      return translator(`Role`);
    }

    return translator("Practice Categories");
  }

  const title = returnTitle(moduleKeys, moduleName);

  return (
    <>
      <Header title={title} subtitle="" />
      <ConditionalRenderer condition={moduleKeys?.country === moduleName}>
        <Stack direction={"row"} sx={{ background: "#ffffff" }}>
          <Typography variant="subtitle1" mx={4} mt={4} noWrap>
            {translator("generic.Add New")} {translator("Country")}
          </Typography>
        </Stack>
        <CountryAction />
      </ConditionalRenderer>
      <ConditionalRenderer condition={moduleKeys?.themes === moduleName}>
        <Stack direction={"row"} sx={{ background: "#ffffff" }}>
          <Typography variant="subtitle1" mx={4} mt={4} noWrap>
            {translator("generic.Add New")} {`${translator("Theme")}s`}
          </Typography>
        </Stack>
        <ThemesAction />
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={moduleKeys?.geographicalArea === moduleName}
      >
        <Stack direction={"row"} sx={{ background: "#ffffff" }}>
          <Typography variant="subtitle1" mx={4} mt={4} noWrap>
            {translator("generic.Add New")}{" "}
            {`${translator("Geographical Area")}`}
          </Typography>
        </Stack>
        <GeographicalAction />
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={moduleKeys?.policyCategories === moduleName}
      >
        <Stack direction={"row"} sx={{ background: "#ffffff" }}>
          <Typography variant="subtitle1" mx={4} mt={4} noWrap>
            {translator("generic.Add New")}{" "}
            {`${translator("Policy Categories")}`}
          </Typography>
        </Stack>
        <PolicyCategoriesAction />
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={moduleKeys?.practiceCategories === moduleName}
      >
        <Stack direction={"row"} sx={{ background: "#ffffff" }}>
          <Typography variant="subtitle1" mx={4} mt={4} noWrap>
            {translator("generic.Add New")}{" "}
            {`${translator("Practice Categories")}`}
          </Typography>
        </Stack>
        <PracticeCategoriesAction />
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={moduleKeys?.indicatorsCategories === moduleName}
      >
        <Stack direction={"row"} sx={{ background: "#ffffff" }}>
          <Typography variant="subtitle1" mx={4} mt={4} noWrap>
            {translator("generic.Add New")}{" "}
            {translator(`Indicators Categories`)}
          </Typography>
        </Stack>
        <IndicatorsCategoriesAction />
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={moduleKeys?.indicatorsValues === moduleName}
      >
        <Stack direction={"row"} sx={{ background: "#ffffff" }}>
          <Typography variant="subtitle1" mx={4} mt={4} noWrap>
            {translator("generic.Add New")}{" "}
            {`${translator("Indicators Values")}`}
          </Typography>
        </Stack>
        <IndicatorValuesAction />
      </ConditionalRenderer>
      <ConditionalRenderer condition={moduleKeys?.indicators === moduleName}>
        <Stack direction={"row"} sx={{ background: "#ffffff" }}>
          <Typography variant="subtitle1" mx={4} mt={4} noWrap>
            {translator("generic.Add New")} {`${translator("Indicators")}`}
          </Typography>
        </Stack>
        <IndicatorAction />
      </ConditionalRenderer>
      <ConditionalRenderer condition={moduleKeys?.institutions === moduleName}>
        <Stack direction={"row"} sx={{ background: "#ffffff" }}>
          <Typography variant="subtitle1" mx={4} mt={4} noWrap>
            {translator("generic.Add New")} {translator(`Institutions`)}
          </Typography>
        </Stack>
        <InstitutionsAction />
      </ConditionalRenderer>
      <ConditionalRenderer condition={moduleKeys?.role === moduleName}>
        <Stack direction={"row"} sx={{ background: "#ffffff" }}>
          <Typography variant="subtitle1" mx={4} mt={4} noWrap>
            {translator("generic.Add New")} {translator(`Role`)}
          </Typography>
        </Stack>
        <RolesAction />
      </ConditionalRenderer>
      <ConditionalRenderer condition={moduleKeys?.users === moduleName}>
        <Stack direction={"row"} sx={{ background: "#ffffff" }}>
          <Typography variant="subtitle1" mx={4} mt={4} noWrap>
            {translator("generic.Add New")} User
          </Typography>
        </Stack>
        <UsersAction />
      </ConditionalRenderer>
      <ConditionalRenderer condition={moduleKeys?.profiles === moduleName}>
        <Stack direction={"row"} sx={{ background: "#ffffff" }}>
          <Typography variant="subtitle1" mx={4} mt={4} noWrap>
            {translator("generic.Add New")} {translator("generic.Profile")}
          </Typography>
        </Stack>
        <ProfileAction />
      </ConditionalRenderer>
    </>
  );
}

export { AddFeatures };
